<div class="advanced-search">
  <button ds-button variant="ghost-muted" icon="close" class="advanced-search-close-button"
          [attr.aria-label]="'common.close' | translate"
          (click)="hide()"></button>
  <ds-tabs>
    @for (tab of tabs; track tab.titleResource) {
      <ds-tabs-label
        [for]="tab.titleResource"
        [isSelected]="selectedTab.titleResource === tab.titleResource"
        (click)="selectTab(tab)"
        (keydown.enter)="selectTab(tab)"
        (keydown.space)="$event.preventDefault(); selectTab(tab)"
      >{{ tab.titleResource | translate }}
      </ds-tabs-label>
    }
    <ds-tabs-content id="case.typeAttributes">
      <app-advanced-search-tab [selectedTab]="selectedTab">
        <ueg-awp-typecode [authInfo]="authInfo"
                          [locale]="user?.getLocale()"
                          (typeCodeSelected)="typeCodeSelected($event['detail'])">
        </ueg-awp-typecode>
      </app-advanced-search-tab>
    </ds-tabs-content>

    <ds-tabs-content id="case.keyPool">
      <app-advanced-search-tab [selectedTab]="selectedTab">
        <app-key-pool (vinSelected)="vinSelected($event)"></app-key-pool>
      </app-advanced-search-tab>
    </ds-tabs-content>

    @if (customerSearchEnabled()) {
      <ds-tabs-content id="case.customerName">
        <app-advanced-search-tab [selectedTab]="selectedTab">
          <app-customer-search
            (selectedVehicle)="dmsVehicleSelected($event, VehicleSearchOrigin.DMS_CUSTOMER_NAME)"></app-customer-search>
        </app-advanced-search-tab>
      </ds-tabs-content>
    }

    @if (licensePlateSearchEnabled()) {
      <ds-tabs-content id="case.licensePlate">
        <app-advanced-search-tab [selectedTab]="selectedTab">
          <app-dms-license-plate-search
            (selectedVehicle)="dmsVehicleSelected($event, VehicleSearchOrigin.DMS_LICENSE_PLATE)"></app-dms-license-plate-search>
        </app-advanced-search-tab>
      </ds-tabs-content>
    }

    @if (orderSearchEnabled()) {
      <ds-tabs-content id="case.dmsOrderNumber">
        <app-advanced-search-tab [selectedTab]="selectedTab">
          <app-dms-order-search
            (selectedVehicle)="dmsVehicleSelected($event, VehicleSearchOrigin.DMS_ORDER_NUMBER)"></app-dms-order-search>
        </app-advanced-search-tab>
      </ds-tabs-content>
    }

    @if (customerDataSearchEnabled()) {
      <ds-tabs-content id="case.customerAndLicenseSearch">
        <app-advanced-search-tab [selectedTab]="selectedTab">
          <app-customer-data-search
            [locale]="user?.getLocale()"
            [businessPartnerId]="user?.getBusinessPartner()?.getBusinessPartnerId()"
            [authInfo]="authInfo"
            (vinSelected)="customerDataVehicleSelected($event)"
            (customerProfileSelected)="customerDataProfileSelected($event)"></app-customer-data-search>
        </app-advanced-search-tab>
      </ds-tabs-content>
    }
  </ds-tabs>
</div>
